'use client';
import { jsx } from 'react/jsx-runtime';
import { renderWithRef } from '../../core/render-with-ref.js';
import { RenderComp } from '../../core/render-comp.component.js';

const Span = renderWithRef('Span', null, (e, t)=>{
    let { children: n } = e;
    return jsx(RenderComp, {
        root: "span",
        forwardedRef: t,
        props: e,
        children: n
    });
});

export { Span };
